/* eslint-disable react/function-component-definition */
/* Global imports. */
import React, { useState, useEffect } from "react"; 
import {Link} from "gatsby";
import { getFormat } from "@src/onix"

import Buy from "@components/Buy";
import EditionImage from "@components/EditionImage";
import { PanMacmillanEdition } from "@src/models/panmacmillan";
import { convertKontentImageURLToImageKitURL } from "@src/imagekit";

interface Props {
  title: string;
  isbn: string;
  primaryAuthorName: string;
  description: string;
  isPanMacmillanTitle: "yes" | "no";
  jacketImagePath: string; 
  localImagePath: string;
  altJacket:  string;
  editionUrl: string;
  authorUrl: string;
  format: string;
  imprint: string;
  hideDescription: boolean;
  isPreOrder: boolean;
  jacketWidth?: number;
  jacketHeight?: number;
  referringSlug?: string;
  isQuickPreview?: boolean;
  kontentImage?: any
  customURL?: string;
}

const BookSpotlight = ({ title, isbn, primaryAuthorName, description, editionUrl, authorUrl, isPanMacmillanTitle, altJacket, jacketImagePath, format, imprint, localImagePath, hideDescription, isPreOrder, jacketWidth, jacketHeight, referringSlug, isQuickPreview, kontentImage, customURL }: Props) => {
const resolvedFormat = getFormat(format)
if(kontentImage && kontentImage.url) {
    kontentImage.url = convertKontentImageURLToImageKitURL(kontentImage.url)
}
const editionImage = <EditionImage isbn={isbn} kontentImage={kontentImage} altImagePath={altJacket} title={title} width={jacketWidth} height={jacketHeight} />

return (
<figure data-component="book-spotlight" className="block sm:grid sm:grid-flow-col w-full mb-4 book-spotlight">
  <figcaption className="inline-block mb-4 sm:mb-6 order-1 sm:order-2 justify-self-start">
    <h3 className="mb-1 text-lg font-bold sm:text-2xl">{editionUrl ? <Link data-ref-slug={referringSlug} data-title={title} data-author={primaryAuthorName} data-format={resolvedFormat} data-isbn={isbn} data-ispanmac={isPanMacmillanTitle} to={editionUrl} data-ref-component-type="book-spotlight" className="underline hover:text-link tm-title">{title}</Link> : `${title}`}</h3>
    {authorUrl && primaryAuthorName ?
    <h4 className="mb-0 text-base font-normal">by <Link data-ref-slug={referringSlug} data-author={primaryAuthorName} data-isbn={isbn} data-ispanmac={isPanMacmillanTitle} data-title={title} data-format={resolvedFormat} data-ref-component-type="book-spotlight" className="font-serif underline hover:text-link tm-author" to={authorUrl}><span dangerouslySetInnerHTML={{ __html: primaryAuthorName }} /></Link></h4>
      : primaryAuthorName && <h4 className="mb-0 text-base font-normal">by <span className="font-serif" dangerouslySetInnerHTML={{ __html: primaryAuthorName }} /></h4>
    }
  </figcaption>
  <div className="mb-4 flex flex-wrap justify-center mx-auto sm:ml-0 sm:mr-6 w-[180px] sm:w-[224px] book-spotlight-jacket order-2 sm:order-1 sm:row-span-3">
	<div className="w-full">
		{editionUrl ? <Link data-ref-slug={referringSlug} data-title={title} data-author={primaryAuthorName} data-format={resolvedFormat} data-isbn={isbn} data-ispanmac={isPanMacmillanTitle} to={editionUrl} data-ref-component-type="book-spotlight" className="underline hover:text-link tm-title w-full">{editionImage}</Link> : editionImage}
		
		<div className="hidden w-full mt-4 sm:block">
          {customURL ? (
            <a href={customURL} target="_blank" rel="noopener noreferrer" className="whitespace-break-spaces pl-4 block py-3 w-full appearance-none text-left font-bold overflow-hidden h-[3rem] text-[1.125rem] rounded-md bg-green hover:bg-green-light border-solid border border-green hover:border-green-light text-white visible">
                <span className="inline-block pb-[0.75rem]">Buy</span>
                <span className="whitespace-pre inline-block"> the book</span>
            </a>
          ) : (isbn && title && primaryAuthorName || isQuickPreview) ? (
            <Buy referringComponent="book-spotlight" referringSlug={referringSlug} isbn={isbn} author={primaryAuthorName} title={title} format={format} imprint={imprint} isPreOrder={isPreOrder} isPanMacmillanTitle={isPanMacmillanTitle} isQuickPreview={isQuickPreview}/>
          ) : null}
		</div>
	</div>
  </div>
 
  <div className="rte--default order-3 p-inherit">
      {!hideDescription && description && description !== "<p><br></p>" && <div dangerouslySetInnerHTML={{ __html: description }} /> }
  </div>
  <div className="flex flex-wrap justify-center mt-8 mb-4 max-w-[240px] mx-auto sm:hidden order-4">
    {customURL ? (
    <a href={customURL} target="_blank" rel="noopener noreferrer" className="whitespace-break-spaces pl-4 block py-3 w-full appearance-none text-left font-bold overflow-hidden h-[3rem] text-[1.125rem] rounded-md bg-green hover:bg-green-light border-solid border border-green hover:border-green-light text-white visible">
        <span className="inline-block pb-[0.75rem]">Buy</span>
        <span className="whitespace-pre inline-block"> the book</span>
    </a>
    ) : (isbn && title && primaryAuthorName || isQuickPreview) ? (
    <Buy referringComponent="book-spotlight" referringSlug={referringSlug} isbn={isbn} author={primaryAuthorName} title={title} format={format} imprint={imprint} isPreOrder={isPreOrder} isPanMacmillanTitle={isPanMacmillanTitle} isQuickPreview={isQuickPreview} />
    ) : null}
  </div>
</figure>
)
};

export default BookSpotlight;
